module.exports = __webpack_public_path__ + "img/no-records-svg.246c8ec5.svg";